module.exports = __webpack_public_path__ + "static/404_cloud_blue.376e027a.png";